// ==============================|| LOGO ICON (collapsed sidebar) ||============================== //
//
// Icon-only mark shown when the sidebar is collapsed (mini drawer): a rounded
// teal square with a checkmark — fits the checklist / submissions domain and the
// Ops Deck brand (#0E9498).

const LogoIcon = () => {
  // Ops Deck teal stops — a brighter teal into the brand teal — so the mark stays
  // distinct on the dark teal sidebar and reads well on white auth/footer surfaces.
  const primary = '#16B4B8';
  const primaryDark = '#0E9498';

  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="hexaLogoGradient"
          x1="0"
          y1="0"
          x2="36"
          y2="36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={primary} />
          <stop offset="1" stopColor={primaryDark} />
        </linearGradient>
      </defs>
      <rect width="36" height="36" rx="9" fill="url(#hexaLogoGradient)" />
      <path
        d="M10.5 18.75L15.25 23.5L25.5 12.5"
        stroke="#fff"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LogoIcon;
